export default "__VITE_PUBLIC_ASSET__9558c479__"